import { Spinner } from '@/components/ui/Spinner'

export function LoadingBar() {
  return (
    <div className="flex items-center gap-2 text-muted text-sm font-light">
      <Spinner />
      Loading...
    </div>
  )
}
